import React from "react";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

export default function Input({ label, ...rest }: InputProps) {
  return (
    <div style={{ marginBottom: 12 }}>
      <label>{label}</label>
      <input {...rest} style={{ display: "block", padding: 8, width: "100%" }} />
    </div>
  );
}
